export default __webpack_public_path__ + "static/media/ACF.a2a9d158.jpg";